<div class="main-wrapper text-center">
        <div class="error-box">
            <h1>404</h1>
            <h3><i class="fa fa-warning"></i> Oops! Page not found!</h3>
            <p>The page you requested was not found.</p>
            <a routerLink="/dashboard" class="btn btn-primary go-home">Go to Home</a>
        </div>
    </div>